import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { icons } from '@/assets/fontawesome/icons'

// `VendoredIcon` widens `iconName` past Font Awesome's own catalog so the custom
// `fak` glyphs can be typed; the shape is otherwise an `IconDefinition`.
library.add(...(icons as unknown as IconDefinition[]))

export default FontAwesomeIcon
